import { useSelector } from 'react-redux'
import { selectDocsFormData } from '../../redux-state/selectors'
import { FUEL_TYPE_MAP } from '../docs/constants'

function VehicleInformation() {
  const docsFormData = useSelector(selectDocsFormData)

  return (
    <>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Vehicle Information <span className='text-xs text-gray-600 font-normal ml-1'>{docsFormData?.vinCode}</span>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {docsFormData?.vehicleType &&
            <div className='flex flex-row justify-between'>
              <div>
                Vehicle Type:
              </div>
              <div className='font-medium'>
                {docsFormData?.vehicleType}
              </div>
            </div>
          }

          {docsFormData?.modelYear &&
            <div className='flex flex-row justify-between'>
              <div>
                Model Year:
              </div>
              <div className='font-medium'>
                {docsFormData?.modelYear}
              </div>
            </div>
          }

          {docsFormData?.model &&
            <div className='flex flex-row justify-between'>
              <div>
                Model:
              </div>
              <div className='font-medium'>
                {docsFormData?.model}
              </div>
            </div>
          }

          {docsFormData?.numberOfAxles &&
            <div className='flex flex-row justify-between'>
              <div>
                Number of Axles:
              </div>
              <div className='font-medium'>
                {docsFormData?.numberOfAxles}
              </div>
            </div>
          }

          {docsFormData?.fuelType &&
            <div className='flex flex-row justify-between'>
              <div>
                Fuel Type:
              </div>
              <div className='font-medium'>
                {FUEL_TYPE_MAP[docsFormData?.fuelType]}
              </div>
            </div>
          }


          {docsFormData?.registrationMonths &&
            <div className='flex flex-row justify-between'>
              <div>
                Registration Months:
              </div>
              <div className='font-medium'>
                {docsFormData?.registrationMonths}
              </div>
            </div>
          }

          {docsFormData?.odometer &&
            <div className='flex flex-row justify-between'>
              <div>
               Odometer:
              </div>
              <div className='font-medium'>
                {docsFormData?.odometer}
              </div>
            </div>
          }

          {docsFormData?.color &&
            <div className='flex flex-row justify-between'>
              <div>
                Color:
              </div>
              <div className='font-medium'>
                {docsFormData?.color}
              </div>
            </div>
          }

          {docsFormData?.gvw &&
            <div className='flex flex-row justify-between'>
              <div>
                GVW (lbs):
              </div>
              <div className='font-medium'>
                {docsFormData?.gvw}
              </div>
            </div>
          }
          
          {docsFormData?.horsepower &&
            <div className='flex flex-row justify-between'>
              <div>
                Horsepower:
              </div>
              <div className='font-medium'>
                {docsFormData?.horsepower}
              </div>
            </div>
          }
        </div>

        <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
          {docsFormData?.condition &&
            <div className='flex flex-row justify-between'>
              <div>
                Condition:
              </div>
              <div className='font-medium'>
                {docsFormData?.condition}
              </div>
            </div>
          }

          {docsFormData?.make &&
            <div className='flex flex-row justify-between'>
              <div>
                Make:
              </div>
              <div className='font-medium'>
                {docsFormData?.make}
              </div>
            </div>
          }

          {docsFormData?.bodyStyle &&
            <div className='flex flex-row justify-between'>
              <div>
                Body Style:
              </div>
              <div className='font-medium'>
                {docsFormData?.bodyStyle}
              </div>
            </div>
          }

          {docsFormData?.numberOfTires &&
            <div className='flex flex-row justify-between'>
              <div>
                Number of Tires:
              </div>
              <div className='font-medium'>
                {docsFormData?.numberOfTires}
              </div>
            </div>
          }

          {docsFormData?.cylinders &&
            <div className='flex flex-row justify-between'>
              <div>
                Cylinders:
              </div>
              <div className='font-medium'>
                {docsFormData?.cylinders}
              </div>
            </div>
          }

          {docsFormData?.rimSize &&
            <div className='flex flex-row justify-between'>
              <div>
                Rim Size (inches):
              </div>
              <div className='font-medium'>
                {docsFormData?.rimSize}
              </div>
            </div>
          }
          
          {docsFormData?.vehicleWeight &&
            <div className='flex flex-row justify-between'>
              <div>
                Weight (Ibs):
              </div>
              <div className='font-medium'>
              {docsFormData?.vehicleWeight}
              </div>
            </div>
          }

          {docsFormData?.mpg &&
            <div className='flex flex-row justify-between'>
              <div>
                MPG (Average):
              </div>
              <div className='font-medium'>
                {docsFormData?.mpg}
              </div>
            </div>
          }

          {docsFormData?.msrp &&
            <div className='flex flex-row justify-between'>
              <div>
                MSRP:
              </div>
              <div className='font-medium'>
                ${docsFormData?.msrp}
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default VehicleInformation
